import { type FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import Tooltip from '../Tooltip/Tooltip';
import styles from './InfoPill.module.scss?module';
import clsx from 'clsx';

export interface InfoPillProps {
  icon: IconDefinition;
  value: string | number;
  tooltip: string;
  compact?: boolean;
  hideIcon?: boolean;
}

const InfoPill: FC<InfoPillProps> = ({
  icon,
  value,
  tooltip,
  compact = false,
  hideIcon = false,
}) => {
  return (
    <div className={clsx(styles.InfoPill, compact ? styles.compact : '')}>
      <Tooltip title={tooltip} placement="top">
        <span className={styles.Pill}>
          {!hideIcon && <FontAwesomeIcon icon={icon} className={styles.Icon} />}
          <span className={styles.Value}>{value}</span>
        </span>
      </Tooltip>
    </div>
  );
};

export default InfoPill;
